import { Badge } from '../ui';
import type { TierLevel } from '../../api/types';
import { tierMeta } from './tier';

export interface TierBadgeProps {
  level: TierLevel;
  /** When true, show only the short code (e.g. "T2"); else "T2 · Intermediate". */
  compact?: boolean;
  size?: 'xs' | 'sm' | 'md';
}

/**
 * TierBadge — a single competency-tier chip (T1..T4) colour-coded by tier.
 * Reused by the roadmap, the result screen, and the AppShell nav summary.
 */
export function TierBadge({ level, compact = false, size = 'sm' }: TierBadgeProps) {
  const meta = tierMeta(level);
  return (
    <Badge variant={meta.variant} size={size}>
      {compact ? meta.code : `${meta.code} · ${meta.label}`}
    </Badge>
  );
}
